import { Input, Button, Space, Tag } from 'antd';
import { SearchOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import _ from 'lodash';

export const PortfolioTableConfig = (
  handleSearch,
  handleReset,
  editPortfolio,
  responsibilities,
) => {
  const getColumnSearchProps = (dataIndex) => {
    return {
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
    };
  };
  return [
    {
      title: 'ID',
      dataIndex: 'portfolio_id',
      key: 'portfolio_id',
      width: '4%',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'vendor',
      width: '10%',
      ...getColumnSearchProps('category'),
    },

    {
      title: 'Name',
      dataIndex: 'portfolio_name',
      key: 'portfolio_name',
      width: '5%',
      ...getColumnSearchProps('portfolio_name'),
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      width: '3%',
    },
    {
      title: 'Picture',
      dataIndex: 'picture',
      key: 'picture',
      width: '3%',
    },
    // {
    //   title: 'Order',
    //   dataIndex: 'productorder',
    //   key: 'productorder',
    //   width: '3%',

    // },
    {
      title: 'isHomePage',
      dataIndex: 'ishomepageport',
      key: 'ishomepageport',
      width: '3%',
      render: (ishomepageport) => {
        return <Tag color={ishomepageport ? 'green' : 'red'}>{ishomepageport ? 'Yes' : 'No'}</Tag>;
      },
    },
    {
      title: 'Status',
      dataIndex: 'isactive',
      key: 'isactive',
      width: '5%',
      render: (status) => {
        return <Tag color={status ? 'green' : 'red'}>{status ? 'Active' : 'In Active'}</Tag>;
      },
    },
    {
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: '2%',
      render: (item) => {
        return (
          <div>
            <Space size="middle">
              <EyeOutlined style={{ color: '#0D8616', cursor: 'pointer', fontSize: '20px' }} />
              {_.includes(responsibilities, 'PRODUCT_PORTFOLIO_EDIT_BUTTON') ? (
                <EditOutlined
                  style={{ color: '#0D4B86', cursor: 'pointer', fontSize: '20px' }}
                  onClick={() => editPortfolio(item)}
                />
              ) : (
                ''
              )}
            </Space>
          </div>
        );
      },
    },
  ];
};
